<script setup lang="ts">
import { computed } from 'vue'
import { formatAddressToSingleLineSimple } from '../../util/address'

const props = defineProps<{
  city?: string
  state?: string
  street1?: string
  title?: string
}>()

const address = computed(() => {
  return formatAddressToSingleLineSimple(props.street1, props.city, props.state)
})
</script>
<template>
  <div>
    <template v-if="!title">
      <h4 class="timeline-stop__title">
        {{ address }}
      </h4>
    </template>
    <template v-else>
      <h4>
        {{ title }}
      </h4>
      <div class="timeline-stop__title">
        {{ address }}
      </div>
    </template>
  </div>
</template>
<style lang="scss" scoped>
h4 {
  font-size: 1rem;
  line-height: 1;
  font-weight: 600;
  margin: 0;
}
</style>
